import { useIntl } from '@weenat/wintl'
import { Head } from 'app/routx-router'
import ChangePassword from 'app/src/authentication/components/ChangePassword'
import HeaderActions from 'app/src/layouts/HeaderActions'
import ChangeEmail from 'app/src/me/ChangeEmail'
import DeleteMyAccount from 'app/src/me/DeleteMyAccount'

const Account = () => {
  const { t } = useIntl()

  return (
    <>
      <HeaderActions />
      <Head title={t(`titles.my_account`)} />
      <ChangeEmail />
      <ChangePassword />
      <DeleteMyAccount />
    </>
  )
}

export const Component = Account
export default Account
